export default "__VITE_ASSET__BRSQloq2__"